import { Box, FormLabel, TextField, TextFieldProps } from '@mui/material';
import React, { useState } from 'react';
import {
  Controller,
  UseControllerProps,
  useFormContext,
} from 'react-hook-form';

type OutlinedLabeledTextFieldProps = UseControllerProps & {
  textFieldProps: TextFieldProps;
  defaultValue?: string;
  formLabel?: string;
};

export default function OutlinedLabeledTextField({
  formLabel,
  defaultValue,
  textFieldProps,
  ...props
}: OutlinedLabeledTextFieldProps) {
  const { control } = useFormContext();
  const { name } = props;
  const [value, setValue] = useState(defaultValue || '');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'start',
        gap: 1,
        width: 1,
      }}
    >
      {formLabel && (
        <FormLabel sx={{ fontSize: 12, pl: 1.5 }} htmlFor={textFieldProps.id}>
          {formLabel}
        </FormLabel>
      )}

      <Controller
        name={name}
        control={control}
        rules={{ required: true }}
        defaultValue={defaultValue || ''}
        render={({ field }) => (
          <TextField
            {...field}
            {...textFieldProps}
            value={value}
            variant="outlined"
            onChange={(e) => {
              field.onChange(e);
              setValue(e.target.value);
            }}
            sx={{
              ...textFieldProps.sx,
              '& .MuiInputBase-root': { borderRadius: 4 },
              '& .MuiOutlinedInput-notchedOutline': { borderRadius: 4 },
            }}
          />
        )}
      ></Controller>
    </Box>
  );
}
